import { Text } from "@primer/react";
import { formatPercentage } from "../EditablePercentage/EditablePercentage.jsx";
import "./PolicyRangeMeter.css";

export function PolicyRangeMeter({ policy }) {
  const minimum = policy.must.minimum ?? 0;
  const maximum = policy.must.maximum;
  const should = policy.should ?? {};
  const hasIdeal = should.minimum !== undefined || should.maximum !== undefined;
  const idealMinimum = Math.max(minimum, should.minimum ?? minimum);
  const idealMaximum = Math.min(maximum, should.maximum ?? maximum);
  const span = maximum - minimum;
  const idealStart = span ? ((idealMinimum - minimum) / span) * 100 : 50;
  const idealWidth = span ? ((idealMaximum - idealMinimum) / span) * 100 : 0;
  const idealEnd = idealStart + idealWidth;
  const meterClassName = ["policy-meter", span ? null : "exact", idealWidth > 0 && idealWidth < 28 ? "crowded" : null].filter(Boolean).join(" ");
  const description = hasIdeal ? `Compliant from ${formatPercentage(minimum)}% to ${formatPercentage(maximum)}%; ideal from ${formatPercentage(idealMinimum)}% to ${formatPercentage(idealMaximum)}%` : `Compliant from ${formatPercentage(minimum)}% to ${formatPercentage(maximum)}%`;
  return <div className={meterClassName} role="img" aria-label={description}>
    <span className="policy-meter-plot"><span className="policy-meter-track" />{hasIdeal ? <span className={`policy-meter-ideal${idealWidth ? "" : " point"}`} style={{ "--position": `${idealStart}%`, "--width": `${idealWidth}%` }} /> : null}<MeterIdealLabels hasIdeal={hasIdeal} idealEnd={idealEnd} idealMaximum={idealMaximum} idealMinimum={idealMinimum} idealStart={idealStart} idealWidth={idealWidth} maximum={maximum} minimum={minimum} /><MeterLabel level="must" position={span ? 0 : 50} side={span ? "minimum" : "exact"} value={minimum} />{maximum !== minimum ? <MeterLabel level="must" position={100} side="maximum" value={maximum} /> : null}</span>
  </div>;
}

function MeterIdealLabels({ hasIdeal, idealEnd, idealMaximum, idealMinimum, idealStart, idealWidth, maximum, minimum }) {
  if (!hasIdeal) return null;
  const showMinimum = idealMinimum !== minimum;
  const showMaximum = idealMaximum !== maximum && idealMaximum !== idealMinimum;
  if (!showMinimum && !showMaximum) return null;
  if (!idealWidth) return <MeterLabel level="ideal" position={idealStart} side="range" value={idealMinimum} />;
  if (idealWidth > 0 && idealWidth < 28) {
    const values = [showMinimum ? idealMinimum : null, showMaximum ? idealMaximum : null].filter((value) => value !== null);
    return <MeterLabel level="ideal" position={idealStart + (idealWidth / 2)} side="range" value={values.map((value) => `${formatPercentage(value)}%`).join("–")} />;
  }
  return <>{showMinimum ? <MeterLabel level="ideal" position={idealStart} side="minimum" value={idealMinimum} /> : null}{showMaximum ? <MeterLabel level="ideal" position={idealEnd} side="maximum" value={idealMaximum} /> : null}</>;
}

function MeterLabel({ level, position, side, value }) {
  const label = typeof value === "number" ? `${formatPercentage(value)}%` : value;
  return <Text aria-hidden="true" className={`policy-meter-label ${level} ${side}`} style={{ "--position": `${position}%` }}>{label}</Text>;
}
